import React from 'react';
import { Box, Button, PasswordInput, Stack, Text } from '@mantine/core';

import ErrorAlert from '@/components/ErrorAlert';
import { UseFormReturnType } from '@mantine/form';
import { FormValues } from './useForgotPasswordReset';
import PasswordRequirement from '@/components/PasswordRequirement';

interface ForgotPasswordResetSuccessProps {
  onSubmit: () => void;
  form: UseFormReturnType<FormValues>;
  loading: boolean;
  error: string;
  passwordRequirements: Array<{ re: RegExp; label: string; meets: boolean }>;
}

const ForgotPasswordResetContext: React.FC<ForgotPasswordResetSuccessProps> = ({
  onSubmit,
  form,
  loading,
  error,
  passwordRequirements,
}) => {
  return (
    <>
      <Text fz="2rem" fw="bold" mt="md">
        Reset Password
      </Text>
      <Text mt="md">Enter your new password for Fooda for Restaurants.</Text>
      {error && (
        <Box mt="md">
          <ErrorAlert>{error}</ErrorAlert>
        </Box>
      )}
      <form onSubmit={onSubmit}>
        <PasswordInput
          mt="md"
          size="lg"
          label="New password"
          withAsterisk
          autoComplete="new-password"
          disabled={loading}
          {...form.getInputProps('password')}
        />
        <PasswordInput
          mt="md"
          size="lg"
          label="Confirm new password"
          withAsterisk
          autoComplete="new-password"
          disabled={loading}
          {...form.getInputProps('passwordConfirmation')}
        />
        <Box mt="md">
          <Stack gap="xs">
            {passwordRequirements.map((requirement) => (
              <PasswordRequirement
                key={requirement.label}
                label={requirement.label}
                meets={requirement.meets}
              />
            ))}
          </Stack>
        </Box>
        <Button
          mt="md"
          size="lg"
          fullWidth
          type="submit"
          loading={loading}
          disabled={!passwordRequirements.every((req) => req.meets)}
        >
          Reset Password
        </Button>
      </form>
      <Text mt="md">
        Once your password has been reset, you can use your new password to log into Fooda for
        Restaurants.
      </Text>
    </>
  );
};

export default ForgotPasswordResetContext;
